import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Subscription } from "rxjs";
import { Company } from "src/app/models/Company";
import { CompanyService } from "src/app/services/company.service";

import { FsJob } from "./../../models/FsJob";
import { FieldServiceService } from "./../../services/field-service.service";

@Component({
  selector: "app-field-service-info",
  templateUrl: "./field-service-info.component.html",
  styleUrls: ["./field-service-info.component.scss"],
  standalone: false,
})
export class FieldServiceInfoComponent implements OnInit {
  faSpinner = faSpinner;
  subscription: Subscription;
  company: Company;
  fsJob: FsJob;
  companyId: string;
  jobNumber: string;
  status: string; // planned or last job, need to fetch correct details
  isLoading: boolean;

  constructor(
    public fsService: FieldServiceService,
    private companyService: CompanyService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.companyId = this.route.parent.snapshot.paramMap.get("companyId");
    this.jobNumber = this.route.parent.snapshot.paramMap.get("jobNumber");
    this.status = this.route.parent.snapshot.paramMap.get("status");
    this.company = this.companyService.selectedCompany;

    if (!this.company?.name || this.company.name != this.companyId) return;
    this.getFsJobDetails();
  }

  getFsJobDetails() {
    this.isLoading = true;
    this.fsService.get(this.companyId, this.jobNumber).subscribe(
      (response) => {
        this.isLoading = false;
        if (!response) return;
        this.fsJob = response;
      },
      () => (this.isLoading = false),
    );
  }
}
